import Laptop from "../assets/images/podplistic/Laptop.png";
import scroll from "../assets/images/podplistic/scroll.gif";

function Podplistic() {
  return (
    <div className="podplistic">
      <section className="display">
        <img src={Laptop} alt="prototype of project" loading="lazy" />
      </section>
      <section className="overview">
        <h1>PODPLISTIC</h1>
        <div className="the_short">
          <div>
            <h4>ROLE</h4>
            <p>
              Project Manager <br />
              Designer <br />
              Web Developer <br />
              Tester
            </p>
          </div>
          <div>
            <h4>Duration</h4>
            <p>4 Days</p>
          </div>
          <div>
            <h4>Product</h4>
            <p>Website</p>
          </div>
          <div>
            <h4>Tools</h4>
            <p>
              Figma <br />
              Framer
            </p>
          </div>
        </div>

        <div className="the_long">
          <div>
            <h4>Overview</h4>
            <p>
              Podplistic is a small business innovating in the podcasting space
              by leveraging AI to streamline podcast production. Their goal:
              reduce the time it takes to produce and release episodes. <br />
              <br />I was brought on to design and build a one-page website to
              clearly communicate their concept to potential investors. The site
              needed to organize raw, unstructured information into a compelling
              narrative, visually convey Podplistic’s value proposition, and
              make it easy for investors to get in touch.{" "}
            </p>
          </div>
          <div>
            <h4>Challenge</h4>
            <p>
              <ul>
                <li>
                  Tight Deadline: 3-day turnaround (initially scoped for 4 days)
                </li>
                <li>
                  Zero UX Research: No time for user testing or extensive
                  discovery
                </li>
                <li>
                  Information Overload: The client provided a large, unfiltered
                  data dump
                </li>
                <li>
                  High Stakes: The site needed to be live before an important
                  investor pitch
                </li>
              </ul>
            </p>
          </div>
        </div>
      </section>

      <section className="process">
        <h1>Process</h1>

        <div>
          <h4>Discovery</h4>
          <ul>
            <li>
              Conducted a client interview to understand the product and goals
            </li>
            <li>
              Established visual direction and aligned on content priorities
            </li>
            <li>Received a bulk file of unfiltered content for the site</li>
          </ul>
        </div>

        <div>
          <h4>Content Strategy</h4>
          <ul>
            <li>Filtered the information down to what was essential</li>
            <li>
              Structured the narrative to clearly explain Podplistic’s offering
            </li>
            <li>Shared the draft for client feedback and revisions</li>
          </ul>
        </div>

        <div>
          <h4>Design</h4>
          <ul>
            <li>Skipped wireframes due to time constraints</li>
            <li>Jumped directly into high-fidelity designs in Figma</li>
            <li>Sourced appropriate assets and visuals</li>
            <li>
              Rapid iteration with the client to fine-tune messaging and layout
            </li>
          </ul>
        </div>

        <div>
          <h4>Development</h4>
          <ul>
            <li>
              Chose Framer for its visual-first development workflow and
              built-in hosting
            </li>
            <li>Learned and implemented Framer on the fly</li>
            <li>Set up and tested contact functionality</li>
            <li>Fixed UI bugs and optimized for launch</li>
          </ul>
        </div>

        <div>
          <h4>Delivery</h4>
          <ul>
            <li>Final site was uploaded to Framer’s hosting</li>
            <li>
              Client received the live link just before their investor meeting
            </li>
            <li>Project launched on time and without issues</li>
          </ul>
        </div>

        <img className="scroll" src={scroll} alt="gif of project prototype" loading="lazy" />
      </section>

      <section className="reflection">
        <h1>Reflection</h1>
        <div>
          <h4>The Power of Pressure</h4>
          <p>
            Doing this project definitely had its challenges. Coming back home
            from work straight to creating the website for an important meeting
            does bring about a feeling of urgency. <br/>Through this I had to take a
            risk on learning Framer on the fly, as coding would have taken too
            long. It was a successful (educated) gamble and I learned a new
            tool, not to mention the confidence boost from pulling this off.
          </p>
        </div>

        <div>
          <h4>First Time For Everything</h4>
          <p>
            This project gave me many "first's". First client, first real world
            project, first time using Framer, first real risk in this industry
            and first confirmation that I can really do this. <br />
            Given more time, I would've liked to conduct some proper research,
            as well as spent more time on the design. It could be tightened up
            in places and perhaps the way the story was told could use revision.
            But considering the circumstances, I'm happy with the result.
          </p>
        </div>
      </section>
    </div>
  );
}

export default Podplistic;
